import { action, observable } from 'mobx'
import { validationContext } from 'validx'
import { validateObject, when } from '@/utils/validx-util'
import { PhysicalAddressEditorViewModel } from '@/features/jobs/info-gathering/PhysicalAddressEditorViewModel'
import type { CheckTaxRefundDeliveryMethod } from './TaxRefundDeliveryMethod'

/**
 * View model for editing a check delivery method. When the profile's
 * address is used, the mailing address is neither validated nor sent.
 */
export class CheckDeliveryMethodEditorViewModel {
  @observable accessor useSameAddressAsContact = true

  readonly physicalAddressVm = new PhysicalAddressEditorViewModel()

  readonly validation = validationContext(this, {
    physicalAddressVm: [
      when(() => !this.useSameAddressAsContact, validateObject()),
    ],
  })

  /**
   * Resets the state of the view model to that of the given method, or
   * defaults if none is specified.
   */
  @action.bound
  reset(method?: CheckTaxRefundDeliveryMethod) {
    this.useSameAddressAsContact = !method?.mailingAddress
    this.physicalAddressVm.reset(method?.mailingAddress ?? undefined)
    this.validation.reset()
  }

  /**
   * Toggles whether the check is mailed to the profile's address.
   */
  @action.bound
  toggleUseSameAddressAsContact() {
    this.useSameAddressAsContact = !this.useSameAddressAsContact
  }

  /**
   * Maps the state of the VM to {@link CheckTaxRefundDeliveryMethod}.
   */
  toDeliveryMethod(): CheckTaxRefundDeliveryMethod {
    return {
      type: 'Check',
      mailingAddress: this.useSameAddressAsContact
        ? null
        : this.physicalAddressVm.toPhysicalAddress(),
    }
  }
}
